export const mcn = (cls: string[]) => `${cls.join(' ')}`.trim();
